//请自行添加语言资源
const sign = {
  shipperName: '货主',
  companyCode: '机构',
  orderNo: 'TMS单号',
  waybillNo: '面单号',
  customerOrderNo: '客户单号',
  soOrSto: '客户相关单号',
  orderType: '订单类型',
  orderDate: '订单日期',
  reqDispatchDate: '要求发货时间',
  transTypeNo: '运输方式',
  reqArriverDate: '要求送达时间',
  carrierNo: '承运商编号',
  carrierName: '承运商名称',
  orderStatusNo: '订单状态',
  originAddrCode: '发货地址编码',
  originAddrName: '发货方',
  originAddrContactMan: '发货人',
  originAddrContactTel: '发货人电话',
  originAddrCityName: '发货城市',
  originAddrLocation: '发货地址',
  destAddrCode: '收货地址编码',
  destAddrName: '收货方',
  destAddrContactMan: '收货人',
  destAddrContactTel: '收货人电话',
  destAddrCityName: '收货城市',
  destAddrLocation: '收货地址',
  totalQty: '总箱数',
  totalVolume: '总体积(M3)',
  totalWeight: '总毛重(KG)',
  totalNetWeight: '总净重(KG)',
  signStatusName: '签收状态',
  rejectReasonName: '拒收原因',
  remark: '备注',
  skuCode: '产品编号',
  skuName: '产品名称',
  qty: '订单数量',
  skuLotNo: '批次号',
  rejectQuantity: '拒收数量',
  lineNo: '行号',
  signTime: '签收日期',
  signStatus: '签收状态',
  signBack: '签收回退',
  signBatch: '批量签收',
  receiptBatch: '批量回单',
  urgentFlag: '是否加急',
  receiptConfirm: '回单确认',
  orderStatusName: '订单状态',
  companyName:'所属机构',
  transTypeName:'运输方式',
  signOperationTime:'签收操作时间',
};
export default sign



// WEBPACK FOOTER //
// ./src/page/sign/lang/sign.zh.js